import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { THIRD_PARTY_SCRIPTS_CONFIG_TOKEN } from '../../tokens';
import {
  IScriptConfig,
  IThirdPartyScriptsConfig,
} from '../interfaces/scripts.config';

@Injectable()
export class ScriptsInjectorService {
  private renderer: Renderer2;

  constructor(
    @Inject(THIRD_PARTY_SCRIPTS_CONFIG_TOKEN)
    private config: IThirdPartyScriptsConfig,
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public injectScripts() {
    if (!this.config) {
      return;
    }

    if (this.config.head) {
      this.config.head.forEach((item) => {
        this.render(item, false);
      });
    }
    if (this.config.body) {
      this.config.body.forEach((item) => {
        this.render(item, true);
      });
    }
  }

  private render(item: IScriptConfig, body = true) {
    const tag: HTMLScriptElement | HTMLStyleElement =
      this.renderer.createElement(item.type);

    if (item.type === 'script') {
      this.renderer.setAttribute(tag, 'type', 'text/javascript');
    }

    tag.innerHTML = item.content;

    const parent = body ? document.body : document.head;
    if (item.prepend) {
      const firstChild = parent.firstChild;
      this.renderer.insertBefore(parent, tag, firstChild);
    } else {
      this.renderer.appendChild(parent, tag);
    }
  }
}
